module.exports = __webpack_public_path__ + "static/media/icon-scissors.bec2f9b3.svg";